export default "/images/404.png?46195e11f4ed691af21c4ceed66d4e21";